/* eslint-disable import/prefer-default-export */

function PostalAddressSchemaSerializer(office) {
  return {
    streetAddress: office.address1,
    addressLocality: office.cityDetails.name,
    addressRegion: office.stateDetails.name,
    postalCode: office.postalCode,
    addressCountry: office.countryDetails.name,
    '@type': 'PostalAddress',
  };
}

function GeoCoordinatesSchemaSerializer(office) {
  return {
    latitude: office.latitude,
    longitude: office.longitude,
    '@type': 'GeoCoordinates',
  };
}

function AggregateRatingSchemaSerializer(office) {
  return {
    ratingValue: office.currentRating.rating || undefined,
    reviewCount: office.currentRating.reviewCount || 0,
    '@type': 'AggregateRating',
    worstRating: 0,
    bestRating: 100,
  };
}

function EntryPointSchemaSerializer(provider, locale) {
  return {
    url: `/providers/${provider.slug}/?utm_medium=google_knowledge_graph&utm_source=google`,
    inLanguage: locale,
    actionPlatform: ['http://schema.org/DesktopWebPlatform'],
    '@type': 'EntryPoint',
  };
}

function ReservationSchemaSerializer() {
  return {
    name: 'Schedule Online',
    '@type': 'Reservation',
  };
}

function ReserveActionSchemaSerializer(provider, locale) {
  return {
    target: EntryPointSchemaSerializer(provider, locale),
    result: ReservationSchemaSerializer(),
    '@type': 'ReserveAction',
  };
}

export function ProviderSchemaSerializer(provider, locale) {
  const aggregateRating =
    provider.office.currentRating?.reviewCount > 0
      ? {
          aggregateRating: AggregateRatingSchemaSerializer(provider.office),
        }
      : {};
  return {
    name: provider.display,
    address: PostalAddressSchemaSerializer(provider.office),
    geo: GeoCoordinatesSchemaSerializer(provider.office),
    image: provider.profile.photo,
    telephone: provider.office.phone,
    ...aggregateRating,
    potentialAction: ReserveActionSchemaSerializer(provider, locale),
    '@context': 'http://schema.org',
    '@type': 'Dentist',
    '@id': `/providers/${provider.id}/`,
  };
}
